import {Component, Input} from '@angular/core'
import {StaticComponentInstance} from '../../static-form/static-form.types'
import {FormControl, Validators} from '@angular/forms'
import {BoilerDecalingStaticJobQuestionsInput, StaticJobQuestionsInput} from '../../../../../../../__generated__/types'
import {TypedFormGroup} from '../../../../../../core/forms/form-controls.model'

@Component({
  templateUrl: './boiler-descaling-static-form.component.html',
})
export class BoilerDescalingStaticFormComponent implements StaticComponentInstance {
  @Input({required: true}) form!: TypedFormGroup<BoilerDecalingStaticJobQuestionsInput>

  readonly volumeOptionsInLiters = [100, 300, 400, 600, 1000]

  public static createForm(): TypedFormGroup<BoilerDecalingStaticJobQuestionsInput> {
    return new TypedFormGroup<BoilerDecalingStaticJobQuestionsInput>({
      boilerSizeInLiters: new FormControl(undefined, [Validators.required]),
    })
  }

  questionsInput(): StaticJobQuestionsInput {
    return {
      boilerDescaling: {
        boilerSizeInLiters: this.form?.value.boilerSizeInLiters || 0,
      },
    }
  }
}
